import { GET_ACADEMIC_YEARS,  GET_BATCHES,  GET_BRANCHES,  GET_GRADES,  GET_NLEARN3_BATCHES, GET_NLEARN3_BRANCHES, GET_NLEARN3_CLASSES, GET_NLEARN3_SECTIONS, GET_NLEARN3_STREAMS, GET_PROJECTS_LIST, GET_SECTIONS, GET_STREAMS } from "utils/graphql/services/live-classes/queries";
import authClientService from "utils/graphql/authClient";
import * as Yup from "yup";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: "Package Name",
            value: "name",
            type: "configue",
        },
        {
            title: "Academic Year",
            value: "academicYearName",
            type: "configue",
        },
        {
            title: "College Name",
            value: "branchName",
            type: "configue",
        },
        {
            title:"Class Name",
            value: "gradeName",
            type: "configue",
        },
        {
            title: "Stream Name",
            value: "streamName",
            type: "configue",
        },
        {
            title: "Batch Name",
            value: "batchName",
            type: "configue",
        },
        {
            title: "Section Name",
            value: "sectionName",
            type: "configue",
        },
        {
            title: "Project Name",
            value: "projectName",
            type:"configue"
        },
        {
            title: "Package Students Count",
            value: "packageStudentsCount",
            type:"configue" 
        }
    ],
    secondaryData: [
            {
            title: "Created At",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt"
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        },
    ],
};

export type Nl3LiveclassPackage = {
    batchId: string;
    gradeId: string;
    branchId: string;
    sectionId: string;
    academicYearId: string;
    streamId: string;
    projectId: string;
};

export const nl3LiveclassPackageInitialValues: Nl3LiveclassPackage = {

    batchId: "",
    gradeId: "",
    branchId: "",
    sectionId: "",
    academicYearId: "",
    streamId: "",
    projectId: "",
};

export const nl3LiveclassPackageMandatoryFields = [
    { id: "batchId" },
    { id: "gradeId" },
    { id: "branchId" },
    { id: "sectionId" },
    { id: "academicYearId" },
    { id: "streamId" },
    { id: "projectId" },
];

export const nl3LiveclassPackageValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
});

export const nl3LiveclassPackageProperties = [

    {
        id:"academicYearId",
        type:"single-select-search",
        label:"Academic Year *",
        // keyValue: { label: "name", value: "nlearn3AcadamicYearId" },
        keyValue: {label: "name", value: "id"},
        query: GET_ACADEMIC_YEARS,
        client: authClientService,
        gqlKey: "getAcademicYears",
        dataKey: "academicYears",
        // extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id: "branchId",
        type: "single-select-search",
        label: "College *",
        keyValue: { label: "name", value: "id" },
        query: GET_BRANCHES,
        client: authClientService,
        gqlKey: "getBranches",
        dataKey: "branches",
        // extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
       {
        id: "gradeId",
        type: "single-select-search",
        label: "Class *",
        keyValue: { label: "name", value: "id" },
        query: GET_GRADES,
        client: authClientService,
        gqlKey: "getGrades",
        dataKey: "grades",
        // extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id: "streamId",
        type: "single-select-search",
        label: "Stream *",
        keyValue: { label: "name", value: "id" },
        query: GET_STREAMS,
        client: authClientService,
        gqlKey: "getStreams",
        dataKey: "streams",
        // extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id: "batchId",
        type: "single-select-search",
        label: "Batch *",
        keyValue: { label: "name", value: "id" },
        query: GET_BATCHES,
        client: authClientService,
        gqlKey: "getBatches",
        dataKey: "batches",
        // extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id:"sectionId",
        type:"single-select-search",
        label:"Section *",
        keyValue: { label: "name", value: "id" },
        query: GET_SECTIONS,
        client: authClientService,
        gqlKey: "getSections",
        dataKey: "sections",
        searchFieldKey: "searchName",
        dependentOn: ["gradeId"],
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
          id: "projectId",
          type: "single-select-search",
          label: "Project",
          keyValue: { label: "name", value: "id" },
          query: GET_PROJECTS_LIST,
          gqlKey: "getProjects",
          dataKey: "projects",
          searchFieldKey: "searchName",
          breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
          required: true,
        },
    ];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}

